/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_SubtitleInputs */

const en_landing_hero_subtitle = /** @type {(inputs: Landing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-native infrastructure that turns published Sell-Side research into secure, AI-ready data for direct workflow integration.`)
};

/**
* | output |
* | --- |
* | "AI-native infrastructure that turns published Sell-Side research into secure, AI-ready data for direct workflow integration." |
*
* @param {Landing_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_subtitle = /** @type {((inputs?: Landing_Hero_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_hero_subtitle(inputs)
});